
import { useState } from "react";
import { Button, Grid } from "@mui/material";
import { LayoutReturn } from "../../../layout";
import { InputDePassword } from "../../../components";
import Swal from "sweetalert2";





export const CambioDePassword = () => {


    // const { startUpdatePassword, } = useUsuarioStore();
    // // const { user } = useAuthStore();
    // const navigate = useNavigate();


    const [passwordAntiguo, setPasswordAntiguo] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirmar, setPasswordConfirmar] = useState('');

    


    const handleCambioClave = async(e) => {
        e.preventDefault();

        console.log(passwordAntiguo, password, passwordConfirmar)

        // const contemPassword = { passwordAntiguo, password, passwordConfirmar,}

        // if( password !== passwordConfirmar ){
        //     return Swal.fire('Error', 'El Nuevo Password Y El Confirmar Password Deben De Ser Iguales.', 'error')
        // }

        // if( [passwordAntiguo, password, passwordConfirmar].includes('') ){
        //     return Swal.fire('Error', 'Todos Los Campos Son Obligatorios.', 'error')
        // }

        // if( !contemPassword.id ){
        //     return Swal.fire('Error', 'Ups Algo Salio Mal.', 'error')
        // }
            
        // const resp = await startUpdatePassword(contemPassword);
        // if( resp ){
        //     setPasswordAntiguo('');
        //     setPassword('');
        //     setPasswordConfirmar('');
        //     navigate('/admin/dashboard');
        // }
    }



    return (

        <LayoutReturn titulo='Cambio de Clave' url={1} >

            <form onSubmit={ handleCambioClave } style={{width:'100%', my:4}}>
                <Grid container sx={{flexDirection:'column', alignItems:'center'}} spacing={2}>
                    
                    <Grid item xs={12} sm={6} sx={{width:'100%'}}>
                        <InputDePassword 
                            value={passwordAntiguo}
                            setValue={setPasswordAntiguo} 
                            placeholder="Clave Anterior"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} sx={{width:'100%'}}>
                        <InputDePassword 
                            value={password}
                            placeholder={'Nuevo Password'} 
                            setValue={setPassword}
                        /> 
                    </Grid>

                    <Grid item xs={12} sm={6} sx={{width:'100%'}}>
                        <InputDePassword 
                            value={passwordConfirmar}
                            placeholder={'Confirmar Password'} 
                            setValue={setPasswordConfirmar}
                        /> 
                    </Grid>

                    <Grid container sx={{width:'100%', my:4}} direccion='column' justifyContent='center' alignItems='center'>
                        <Grid item xs={ 12 } sm={ 6 } >
                            <Button variant='contained' fullWidth type='submit'>
                                Cambiar Password
                            </Button>
                        </Grid>
                    </Grid>

                </Grid>
            </form>
        </LayoutReturn>
        
    )

}
